import styles from './info-subtitle.module.css'

const InfoSubtitle = ({ className, text }: {
    className?: string
    text: string    
}) => {
    return (
        <>                
            <div className={`${styles.subTitleContainer} ${className}`}>
                <div>
                    <span className={styles.roundSpan}>i</span>
                </div>    
                <p>{text}</p>
            </div>            
        </>
)}
export default InfoSubtitle;
